import useAmplitude from '@eversports/amplitude-react/useAmplitude'
import { useEffect, useRef, useState } from 'react'

import { useVenueForGclidTrackingQuery } from '../graphql'

import { GCLID_STORAGE_KEY } from './gclid.constants'

export function useStoreGclid(): void {
  const [gclid, setGclid] = useState<string | null>(null)
  const [venueId, setVenueId] = useState<string | null>(null)
  const { amplitude } = useAmplitude()
  const hasLoggedEvent = useRef(false)

  useEffect(() => {
    const searchParams = new URLSearchParams(window.location.search)
    let storedGclid: string | null = null

    try {
      storedGclid = window.sessionStorage.getItem(GCLID_STORAGE_KEY)
    } catch (error) {}

    // falls back to sessionStorage so a page that lost gclid from its URL (e.g. a step further
    // into checkout than the one that originally captured it) still logs/re-persists it
    setGclid(searchParams.get(GCLID_STORAGE_KEY) ?? storedGclid)
    setVenueId(searchParams.get('venueId'))
  }, [])

  const { data } = useVenueForGclidTrackingQuery({
    variables: { venueId: venueId! },
    skip: !venueId || !gclid,
  })

  // Persisted immediately, independent of amplitude/venue data being ready - EnsureLoggedInUser
  // can redirect to /auth as soon as its own query resolves, and that redirect must not be able
  // to outrun this write.
  useEffect(() => {
    if (!gclid) return

    try {
      window.sessionStorage.setItem(GCLID_STORAGE_KEY, gclid)
    } catch (error) {}
  }, [gclid])

  useEffect(() => {
    if (!gclid || !amplitude || hasLoggedEvent.current) return
    if (venueId && !data) return

    amplitude.logEvent('Visited page with gclid', {
      url: window.location.href,
      'venue.id': data?.venue.id,
      'venue.name': data?.venue.name,
    })
    hasLoggedEvent.current = true
  }, [gclid, venueId, amplitude, data])
}
